// Shared subscription-state helpers.
//
// Cancellation policy: no refunds — a cancelled subscriber keeps full access
// until the end of the billing cycle they already paid for (expires_at),
// after which the subscription is officially over.

export const ONE_TIME_PLANS = ["inperson_3mo_2x", "inperson_6mo_2x", "inperson_single"];

export const PLAN_LABELS = {
  monthly: "Premium · Monthly",
  annual: "Premium · Annual",
  online_monthly: "Online · Monthly",
  online_annual: "Online · Annual",
  inperson_1x_monthly: "In-Person · 1×/week",
  inperson_2x_monthly: "In-Person · 2×/week",
  inperson_3x_monthly: "In-Person · 3×/week",
  inperson_3mo_2x: "In-Person · 3-month package",
  inperson_6mo_2x: "In-Person · 6-month package",
  inperson_single: "In-Person · Single session",
  coach_starter_monthly: "Coach · Starter (monthly)",
  coach_starter_annual: "Coach · Starter (annual)",
  coach_pro_monthly: "Coach · Pro (monthly)",
  coach_pro_annual: "Coach · Pro (annual)",
  coach_studio_monthly: "Coach · Studio (monthly)",
  coach_studio_annual: "Coach · Studio (annual)",
  coach_unlimited_monthly: "Coach · Unlimited (monthly)",
  coach_unlimited_annual: "Coach · Unlimited (annual)",
};

export function planLabel(plan) {
  return PLAN_LABELS[plan] || plan || "—";
}

// Cancelled but still inside the paid billing cycle → access continues.
export function cancelledWithAccess(user) {
  const sub = user?.subscription || {};
  return (
    sub.status === "cancelled" &&
    Boolean(sub.expires_at) &&
    new Date(sub.expires_at) > new Date()
  );
}

// Active but past the paid-through date → a renewal charge failed and is
// retrying. Owner's policy: access is PAUSED until the card successfully
// charges (update card on Pricing to pay now and restore instantly).
export function pastDue(user) {
  const sub = user?.subscription || {};
  return (
    sub.status === "active" &&
    Boolean(sub.expires_at) &&
    new Date(sub.expires_at) <= new Date()
  );
}

// Gate used by premium features (AI coach, meal plans, ...).
export function hasPremiumAccess(user) {
  if (!user) return false;
  if (user.is_admin || user.is_coach) return true;
  const status = user.subscription?.status;
  if (status === "active") return !pastDue(user);
  if (status === "trial" || status === "trialing") return true;
  return cancelledWithAccess(user);
}
